namespace AgerLMS {
    export interface MainPageSettings {
        SliderTitle?: string;
        SliderDetail?: string;
        SliderLottieFile?: string;
        ShowChangeLanguage?: boolean;
        ElephantSvgIcon?: string;
        HomePopupActive?: boolean;
        HomePopup?: string;
        VimeoIframe?: string;
    }
}
